document.addEventListener("DOMContentLoaded", function () {

  // ===== Swiper =====
  function initSwiper(selector, options) {
    const el = document.querySelector(selector);
    if (!el) return null;
    return new Swiper(el, options);
  }

  // ===== Hero Swiper =====
  initSwiper('.tw-hreo_swiper', {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // loop: true,
    autoplay: {
    delay: 6000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
    }
  });

  // ===== Product Swiper =====
  const productSelector = '#swiper_product';
  const productSwiper = initSwiper(productSelector, {
    slidesPerView: 'auto',
    spaceBetween: 24,
    direction: 'horizontal',
    speed: 1000,
    initialSlide: 2,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    parallax: true,
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true
    },
    scrollbar: {
      el: '#swiper_product .ebikes-stats-scroll',
      draggable: true,
    },
    navigation: {
      nextEl: '#swiper_product .swiper-button-next',
      prevEl: '#swiper_product .swiper-button-prev'
    }
  });
  if (productSwiper) productSwiper.slideTo(0, 1, false);

  // ===== Features Swiper =====
  initSwiper('.features_swiper', {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.features-next',
      prevEl: '.features-prev',
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    mousewheel: {
      forceToAxis: true,
      releaseOnEdges: true
    }
  });
  // ===== How-To Swiper =====
  initSwiper('.how-to_swiper', {
    slidesPerView: 'auto', 
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
      mousewheel: {
      forceToAxis: true,
    }
  });
  initSwiper('.media-channels', {
    slidesPerView: 'auto',
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
      mousewheel: {
      forceToAxis: true,
    }
  });
    initSwiper('.reviews-swiper', {
    slidesPerView: 'auto',
    //  loop: true,
      navigation: {
        nextEl: '.reviews-swiper-next',
        prevEl: '.reviews-swiper-prev',
      }, 
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
      mousewheel: {
      forceToAxis: true,
    }
  });
  initSwiper('.Info_swiper', {
    slidesPerView: 1,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                }
            },
  });
  initSwiper('.reviewSwiper', {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
  // ===== Scene Swiper =====
  initSwiper('.scene_swiper', {
         slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
      navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
     autoplay: {
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: true,
    },
      breakpoints: {
                768: {
                    slidesPerView: 1.6,
                }
            },
  });
});
